import { createSlice } from '@reduxjs/toolkit';

/**
 * @fileoverview Slice Redux para gerenciamento do modal de marcas.
 * Controla estado de abertura/fechamento do BrandManager.
 * 
 * @module BrandManagerSlice
 * @since 1.0.0
 */

const brandManagerSlice = createSlice({
  name: 'brandManager',
  initialState: {
    isOpen: false,
  },
  reducers: {
    /**
     * Abre o modal de gerenciamento de marcas.
     */
    openBrandManager: (state) => {
      state.isOpen = true;
    },
    /**
     * Fecha o modal de gerenciamento de marcas.
     */
    closeBrandManager: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openBrandManager, closeBrandManager } = brandManagerSlice.actions;
export default brandManagerSlice.reducer;
